import { config } from '../util/config'

export const fileService = {
  publicUrlFromFileId: (fileId: string): string => {
    return `${config.cdn.publicFileUrl}/${fileId}`
  },
}
